import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
function MainPortalLayout() {
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsx(Outlet, {}), _jsx(Footer, {})] }));
}
export default MainPortalLayout;
